// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconPairing = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M3 9.278c0-1.052.605-2.01 1.556-2.463.475-.226.777-.706.777-1.232V3h2.334v2.583c0 .526.302 1.006.777 1.232A2.73 2.73 0 0110 9.278V19a2 2 0 01-2 2H5a2 2 0 01-2-2zm5 0V19H5V9.278c0-.28.162-.537.415-.657A3.4 3.4 0 006.5 7.8c.296.338.663.62 1.085.82A.73.73 0 018 9.278"
    />,
    <path d="M18 8.86a1 1 0 10-2 0 1 1 0 002 0" />,
    <path
      fillRule="evenodd"
      d="M12 10.668c0-3.06 2.075-5.687 5.032-6.808 2.957 1.121 5.032 3.747 5.032 6.808 0 2.435-1.313 4.595-3.338 5.94h.182l2.195 2.933-.801 1.599H13.8l-.8-1.6 2.242-2.996c-1.97-1.35-3.242-3.48-3.242-5.876m8.064 0c0 1.876-1.143 3.642-3.032 4.622-1.89-.98-3.032-2.746-3.032-4.622s1.143-3.642 3.032-4.621c1.89.98 3.032 2.746 3.032 4.621m-3.01 6.8l-.007.002-1.249 1.67h2.507z"
    />
  );
export default SvgIconPairing;
